import { Moment } from "moment";
import { MinuteRange } from "../types/MinuteRange";
import { getMinMaxMinutes } from "./getMinMaxMinutes";
import { MINUTE_GAP } from "Components/Calendar/CalendarEntryHelper";

export function getVisibleMinutesEnd(
	workingMinutes: MinuteRange,
	startOfWeek: Moment,
	startTimes: number[],
	endTimes: number[]
) {
	const maxStart = getMinMaxMinutes(startOfWeek, startTimes, false);
	const maxEnd = getMinMaxMinutes(startOfWeek, endTimes, false);

	if (maxStart !== null && maxEnd !== null) {
		return Math.max(maxEnd, Math.min(24 * 60, maxStart + MINUTE_GAP));
	} else if (maxEnd !== null) {
		return maxEnd;
	} else if (maxStart !== null) {
		return Math.min(24 * 60, maxStart + MINUTE_GAP);
	} else {
		return workingMinutes.end;
	}
}
